import { X } from 'lucide-react'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react';
import { postdata } from './CareersData'

export default function Jobdescription({ jobindex, click }) {
    const [post, setPost] = useState(null);

    useEffect(() => {
        const postfind = postdata.find((items) => items.id === jobindex)
        setPost(postfind)
        console.log(postfind)
    }, [jobindex])

    return (
        <div className='fixed inset-0 z-50 bg-black bg-opacity-30 backdrop-blur-md' >
            <div className='w-full min-h-[100vh] flex justify-center items-center overflow-y-auto py-10'>

                <div className='w-[70%] max-h-[90vh] p-6 bg-white flex flex-col items-start relative rounded-md overflow-y-auto'>
                    <div className='absolute top-1 right-2 '>
                        <X size={30} onClick={click} className='text-gray-600 cursor-pointer hover:text-black  ' />
                    </div>

                    {post ? (
                        <div className=''>
                            <h1 className=' text-xl sm:text-3xl font-bold font-sans'>{post.position} - Job Description</h1>
                            <p className='text-md text-gray-600 mt-3'>{post.longdescription}</p>

                            <div className='mt-5'>
                                <h1 className='text-lg text-gray-600'>Key Responsibilities:</h1>
                                {post.responsibilities?.map((items, index) => (

                                    <li key={index} className='text-md text-gray-600'>{items}</li>
                                ))}

                            </div>
                            <div className='mt-5'>
                                <h1 className='text-lg text-gray-600'>Requirement:</h1>
                                <li className='text-md text-gray-600'>{post.experience} years of experience in {post.position}</li>
                                {post.skill?.map((items, index) => (

                                    <li key={index} className='text-md text-gray-600'>{items}</li>
                                ))}
                                <h1 className='text-lg text-gray-800 mt-5 '>Salary: {post.Salary}</h1>

                            </div>

                        </div>
                    ) :
                        <p className='text-gray-500'>Loading job description...</p>}

                </div>
            </div>
        </div>
    )
}
